<template>
  <div v-if="item.type==='box'">
    <BoxEdit :item="item">{{layer1}}</BoxEdit>
  </div>
  <div v-else>
    <div>--------------------------------------</div>
    <BoxEdit :item="layer1"></BoxEdit>
  </div>
</template>

<script>

export default {
  props: ['item'],
  computed: {
    layer1 () {
      const item = JSON.parse(JSON.stringify(this.item))
      delete item.contents
      return item
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  line-height: 1.4;
}
.mdBxFiller {
  -webkit-box-flex: 1;
  flex: 1 0 0;
}
</style>
